import { useEffect } from 'react'
import { useRecordingStore } from '@/store/recording.store'

const ACTIVE_RECORDING_STATES = new Set(['recording', 'paused', 'finalizing'])

export const RECORDING_UNLOAD_WARNING =
  'A meeting recording is in progress. Stop it before you refresh or leave, or the recording may be lost.'

declare global {
  interface Window {
    __scramblConfirmRecordingUnload?: () => boolean
    __scramblReloadWithRecordingGuard?: () => void
  }
}

export function isRecordingUnloadBlocked(): boolean {
  return ACTIVE_RECORDING_STATES.has(useRecordingStore.getState().state)
}

export function confirmRecordingUnload(): boolean {
  if (!isRecordingUnloadBlocked()) return true
  return window.confirm(RECORDING_UNLOAD_WARNING)
}

export function reloadPageWithRecordingGuard(): void {
  if (!confirmRecordingUnload()) return
  window.location.reload()
}

export function useRecordingUnloadWarning(): void {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!isRecordingUnloadBlocked()) return

      event.preventDefault()
      event.returnValue = RECORDING_UNLOAD_WARNING
      return RECORDING_UNLOAD_WARNING
    }

    window.__scramblConfirmRecordingUnload = confirmRecordingUnload
    window.__scramblReloadWithRecordingGuard = reloadPageWithRecordingGuard
    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      delete window.__scramblConfirmRecordingUnload
      delete window.__scramblReloadWithRecordingGuard
    }
  }, [])
}
